export function isWishlistSoftDeleted(wishlist: unknown): boolean {
    if (wishlist === null || typeof wishlist !== 'object') {
        return false;
    }
    const status = (wishlist as { status?: unknown }).status;
    return Number(status) === -1;
}
